import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Company, ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { WebhookService } from 'src/app/shared/services/WeebHook/webhook.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Order } from 'src/app/shared/Interfaces/order';
import { typeInterface } from 'src/app/shared/Interfaces/company';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { format } from 'date-fns';

@Component({
  selector: 'app-pedidos',
  templateUrl: './pedidos.component.html',
  styleUrls: ['./pedidos.component.css'],
})
export class PedidosComponent implements OnInit, OnDestroy{
  private timerId: any;
  private webHookSubscription!: Subscription;
  private typeParam!: typeInterface;
  webhookMessages: any[] = [];
  serverDate!: Date;
  currentDate!: Date;
  quantityOrders: number = 3;
  nameCompany: string ='';
  id_company!: string;
  company!: Company
  orders!: Order[]
  requestSucess = false;
  user!: Cliente;
  showTopMenu = true;
  totalOrders: number | undefined = 0;
  theLastOrder = false;
  intervalId: any[] = [];
  intervalsByOrderId: { [orderId: string]: any } = {};
  idsOrders: Order[] = [];

  //#region Inicializadores
    constructor(
      private router: Router,
      private connection: ConnectionService,
      private apiService: ApiService,
      private webHookService: WebhookService,
      private toastr: ToastrService,
      ){

        this.connection.nameCompany$.subscribe((newNameCompany) => {
          this.nameCompany = newNameCompany
        });

        //Resgata o nome da empresa e o parametro se é mesa
        this.connection.typeParam$.subscribe((newTypeParam) => {
          this.typeParam = newTypeParam
        });
        
        this.connection.user$.subscribe((User) =>{
          if(User){
            this.user = User
            if(this.company){
              if(!this.requestSucess)
              {
                this.getOrders();
              }

            }
          }
          else{
            this.connection.getUser(this.id_company);
          }
        })

        this.connection.company$.subscribe((newCompany) =>{
          this.company = newCompany
          if(this.company){
            this.id_company = this.company.company.id_company;
            if(this.user){
              if(!this.requestSucess)
              {
                this.getOrders();
              }
            }
          }

        })
        
        this.checkScreenSize();
    }

    ngOnInit(){
      this.webHookSubscription = this.webHookService.getUpdates().subscribe(
        (content: any) => {
          if(content.type == 1){
            const data = content.data
              this.orders.forEach(order => {
                if(order.id_order == data.company.id_order){
                  order.orderStatus = data.company.orderStatus
                  order.events = data.webhooks
                }
              });
          }
          else if(content.type == 5){
            const data = content.data

            const order = this.idsOrders.find(order => order.id_order == data.id_order)
            const index = this.idsOrders.findIndex(order => order.id_order == data.id_order)
              if(order)
              {
                if(data.status == 1){
                  clearInterval(this.intervalId[index]);
                  this.toastr.clear();
                  this.toastr.success('Pagamento Confirmado.', 'Sucesso', { positionClass: 'toast-top-right', timeOut: 4000});
                  order.orderStatus = 1;
                }
                else if(data.status == 6){
                  clearInterval(this.intervalId[index]);
                  this.toastr.clear();
                  this.toastr.warning('Tempo de pagamento expirado.', 'Pix expirado.', { positionClass: 'toast-top-right', timeOut: 4000});
                  order.orderStatus = 10;
                }
              }

  
          }
        },
        (error) => {
          console.error('Erro ao receber mensagem do servidor WebHook:', error);
        }
      );

      this.getDataServer();
    }

  //#endregion
    ngOnDestroy(): void {
      if(this.webHookSubscription) {
        this.webHookSubscription.unsubscribe();
      }

      this.intervalId.forEach(interval => {
        clearInterval(interval);
      });

      Object.entries(this.intervalsByOrderId).forEach(([orderId, intervalId]) => {
        clearInterval(intervalId);
      });

      if (this.timerId) {
        clearInterval(this.timerId);
      }
      
    }

  //#region Funções de Estilo (Style)

    getProgressBarWidth(order: Order): number {
      const status = order.orderStatus || 1; // Certifique-se de que há um status definido
      return (Number(status) - 1) * 25;
    }

    @HostListener('window:resize', [])
    onWindowResize(event: any) {
      this.checkScreenSize();
    }

    //Verifica o tamanho da tela, esconde o Menu superior se necessario
    checkScreenSize(){
      if(window.innerWidth <= 846){

        this.showTopMenu = false;
      }
      else{
        this.showTopMenu = true;
      }
    }

  //#endregion

  //#region Funções de Lógica (Logic)
  goback(): void{
    if(this.typeParam.type == 3)
    {
      this.router.navigate([this.nameCompany, 'B']);
    }
    else{
      this.router.navigate([this.nameCompany]);
    }
  }

  //Resgata todos pedidos que o usuario ja fez naquele estabelecimento
  getOrders(){
    this.apiService.getOrdersUser(this.user.id_customer, this.id_company, this.quantityOrders).subscribe((response) => {
      this.requestSucess = true;

      this.idsOrders = [];

      this.intervalId.forEach(interval => {
        clearInterval(interval);
      });

      this.intervalId = [];

      if(response.response.info)
      {
        this.orders = response.response.info[0].orders;
        this.totalOrders = response.response.info[0].orders[0].customer.totalOrders;

        if(this.totalOrders){
          if(this.orders.length < this.totalOrders){
            this.theLastOrder = false;
          }
          else{
            this.theLastOrder = true;
          }
        }

        this.orders.forEach((order) => {
          //Valida se o status é 9 e inicia o intervalo de tempo do pix
          if(order.orderStatus == 9)
          {
            this.idsOrders.push(order);
          }

          if(order.scheduled && (order.orderStatus == 1 || order.orderStatus == 2)){
            if(this.validDate(order)){
              order.production = true;
            }
            else{
              order.production = false;
              this.validSchedules(order);
            }
          }
          else{
            order.production = true;
          }
        });

        this.getStatusOrders();
      }
    },
    (error) =>{
      this.requestSucess = false;
    }
    )
  }

  //Valida a cada 10 segundos se o pedido pix foi pago
  getStatusOrders(){
    this.idsOrders.forEach((order, index) => {
      this.intervalId.push(
        setInterval(() =>{
          this.apiService.getStatusOrder(order.id_order.toString()).subscribe(
            (data) =>{
              if(data.status == 1){
                this.toastr.clear();
                this.toastr.success('Pagamento Confirmado.', 'Sucesso', { positionClass: 'toast-top-right', timeOut: 4000});
                order.orderStatus = 1;
                clearInterval(this.intervalId[index])
              }
              else if(data.status == 10){
                clearInterval(this.intervalId[index])
                order.orderStatus = 10;
                this.toastr.clear();
                this.toastr.warning('Tempo de pagamento expirado.', 'Pix expirado.', { positionClass: 'toast-top-right', timeOut: 4000});
              }
            },
            (error) =>{console.log(error);}
          )
        }, 10000)
      )
    });
  }

  //Quantidade de pedido para realizar a requisição de "Ver Mais"
  subquantityOrders(){
    this.quantityOrders += 2;
    this.requestSucess = false;
    setTimeout(() => {
      this.getOrders();
    }, 800);

  }

  //Redireciona para o detalhe do pedido
  orderDetail(id: number){
    this.router.navigate(['/', this.nameCompany, 'order-details', id]);
  }

  //Valida a cada 5 segundos se o pedido agendando está em preparo pela loja
  validSchedules(order: Order){

    if (this.intervalsByOrderId[order.id_order]) {
      console.log('Intervalo já criado para o pedido:', order.displayId);
      return;
    }

    const interval = setInterval(() => {
      if (this.validDate(order)) {
        order.production = true;
        console.log(`Pedido ${order.displayId} está em produção`);
      } else {
        console.log(`Pedido ${order.displayId} não está em produção`);
      }
    }, 5000);

    this.intervalsByOrderId[order.id_order] = interval;
    
  }

  //Valida a data do pedido agendadado com a data do servidor
  validDate(order: Order){
    const dateServer = new Date(this.currentDate);
    const dateReceipt = new Date(order.scheduledReceipt);
    return dateReceipt < dateServer;
  }

  //Resgata o horário do servidor
  getDataServer(){
    this.apiService.getHours().subscribe(
      (data) =>{
        const formatted = format(new Date(data.date), 'dd-MM-yyyy HH:mm');
        console.log('Horário do Servidor', formatted);

        this.serverDate = new Date(data.date);
        this.currentDate = new Date(this.serverDate);
        this.timerId = setInterval(() => {
          this.currentDate = new Date(this.currentDate.getTime() + 1000);
        }, 1000);

      },
      (error) =>{
        console.log(error);
      }
    )
  }

  //Valida o pedido para apresentar o tempo de de preparo
  shouldShowTimeAwait(order: any): boolean {
    const isRelevantStatus = [1, 2, 3, 4].includes(order.orderStatus);

    if (!isRelevantStatus){
      return false;
    }
      
    // Não aparece pois o contador de cancelamento aparece
    if (order.orderStatus === 1 && this.company.configs.autoCancel === 1 && !order.scheduled) {
      return false;
    }

    //Caso o pedido seja agendado
    if(order.orderStatus == 1 && this.company.configs.autoCancel === 1 && order.scheduled && order.production)
    {
      return false;
    }

    return true;
  }

  //#endregion


}
